import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { PurchaseOperationService } from '@core/services/entities/purchase-operation.service';
import { PurchaseOperationResponseDto } from '@domain/purchase-operation/dtos/purchase-operation.response.dto';
import { ListPurchaseOperationRequestDto } from '@domain/purchase-operation/dtos/list-purchase-operation.request.dto';
import { SummaryPurchaseOperationRequestDto } from '@domain/purchase-operation/dtos/summary-purchase-operation.request.dto';
import { SummaryPurchaseOperationResponseDto } from '@domain/purchase-operation/dtos/summary-purchase-operation.response.dto';
import { PurchaseOperationRepository } from '@domain/purchase-operation/repositories/purchase-operation.repository';
import { Observable } from 'rxjs';
import { RefId } from '@core/interface/ref-id.interface';
import { ExportListResponse } from '@core/interface/export-list.interface';
import { ExportPurchaseOperationRequestDto } from '@domain/purchase-operation/dtos/export-purchase-operation.request.dto';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOperationRepositoryService implements PurchaseOperationRepository {
  constructor(private purchaseOperationService: PurchaseOperationService) {}

  list(
    request: ListPurchaseOperationRequestDto,
  ): Observable<ApiResponse<PageableResponse<PurchaseOperationResponseDto>>> {
    return this.purchaseOperationService.list(request);
  }

  show(request: RefId): Observable<ApiResponse<PurchaseOperationResponseDto>> {
    return this.purchaseOperationService.show(request);
  }

  summary(
    request: SummaryPurchaseOperationRequestDto,
  ): Observable<ApiResponse<SummaryPurchaseOperationResponseDto>> {
    return this.purchaseOperationService.summary(request);
  }

  export(
    request: ExportPurchaseOperationRequestDto,
  ): Observable<ApiResponse<ExportListResponse>> {
    return this.purchaseOperationService.export(request);
  }
}
